module.exports = __webpack_public_path__ + "58f3a3b22be8189e68b7a3c2af743074.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_arrow_up_2x.png
// module id = 117
// module chunks = 0 1 2 3 4